// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// ObhliadkyView — desktop register obhliadok (Komercia · lievik dopyt→obhliadka→CP→…). Kópia _ModuleTemplate.
import { confirmLeave, pripravDokument } from '../hooks/unsavedGuard.js'   // p95 — doklad = obrazovka (ústava 67.15)
import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import TelefonInput from '../components/TelefonInput.jsx'
import RowMenu from '../components/RowMenu.jsx'
import { COLORS, TYPO, SPACE, RADIUS, TINT, todayLocal, hladaj, SK } from '../theme.js'   // CAS_ODOSLANIA_V1
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect,
} from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import NoviCustomerDialog from '../components/NoviCustomerDialog.jsx'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import { useToast } from '../components/Toast.jsx'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { normPhone } from '../utils/phone.js'
import SmsButton from '../components/SmsButton.jsx'
import ObhliadkaEditor from './ObhliadkaEditor.jsx'
import SendCustomerDialog from '../components/SendCustomerDialog.jsx'
import { useNavigate } from 'react-router-dom'
import { odkazNaZaznam } from '../hooks/useOtvorZOdkazu.js'   // CP_OTVOR_V1: CP/kalkulácia sa otvára podľa čísla, nie z pamäte pozície

const CFG = { resource: 'obhliadky', apiBase: '/api/obhliadky' }
const STAV_LABEL = { dopyt: 'Dopyt', obhliadka_hotova: 'Obhliadka hotová', cp: 'CP', objednavka: 'Objednávka', vyhrana: 'Vyhraná', prehrana: 'Prehraná' }
const STATUS_FILTERS = [
  { key: 'all', label: 'Všetko', color: COLORS.muted },
  { key: 'dopyt', label: 'Dopyt', color: COLORS.nav },
  { key: 'obhliadka_hotova', label: 'Obhliadka', color: COLORS.nav },
  { key: 'cp', label: 'CP', color: COLORS.brand },
  { key: 'objednavka', label: 'Objednávka', color: COLORS.brand },
  { key: 'vyhrana', label: 'Vyhraná', color: COLORS.add },
  { key: 'prehrana', label: 'Prehraná', color: COLORS.remove },
  { key: 'cakacia', label: 'Čakacia listina', color: COLORS.brand },
]
const stavColor = (s) => s === 'prehrana' ? COLORS.remove : s === 'vyhrana' ? COLORS.add : (s === 'cp' || s === 'objednavka') ? COLORS.brand : COLORS.nav
const fmtD = (d) => { if (!d) return ''; const p = String(d).slice(0, 10).split('-'); return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : d }
// Stav e-mailu v zozname (Mirko 2026-07-17 — „nech je jasné, či e-mail prešiel")
const EmailStav = ({ row }) => row.email_sent_at
  ? <span style={{ color: COLORS.add, fontWeight: TYPO.weights.semibold }}>E-mail {SK.datumCas(row.email_sent_at)}</span>
  : row.email
    ? <span style={{ color: COLORS.warn, fontWeight: TYPO.weights.semibold }}>E-mail neodoslaný</span>
    : <span style={{ color: COLORS.muted }}>Bez e-mailu</span>
const EDIT_FIELDS = [
  { name: 'foto', label: 'Fotky',   // 53.8.A — chýbalo v DIFF: pridanie fotky bez inej zmeny = „Žiadne zmeny"
    format: (v) => Array.isArray(v) ? v.length + ' foto' : '—' },
  { name: 'nazov_dopytu', label: 'Názov dopytu' }, { name: 'customer_id', label: 'Zákazník (číselník)' }, { name: 'kontakt_meno', label: 'Meno/firma' },
  { name: 'telefon', label: 'Telefón' }, { name: 'email', label: 'E-mail' }, { name: 'adresa', label: 'Adresa' },
  { name: 'datum_obhliadky', label: 'Dátum obhliadky' }, { name: 'termin_real', label: 'Termín' },
  { name: 'druh_nehnutelnosti', label: 'Druh' }, { name: 'murivo', label: 'Murivo' }, { name: 'druh_omietky', label: 'Omietka' },
  { name: 'vymera_omietky', label: 'Výmera omietky' }, { name: 'cena_m2', label: 'Cena €/m²' },
  { name: 'stav', label: 'Stav' }, { name: 'obhliadku_robil', label: 'Robil' }, { name: 'poznamka', label: 'Poznámka' },
]

export default function ObhliadkyView() {
  const { user } = useAuth(); const toast = useToast(); const confirm = useConfirm(); const listRef = useRef(null)
  const [rows, setRows] = useState([]); const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState(''); const [filter, setFilter] = useState('all')
  const [selectedId, setSelectedId] = useState(null); const [modal, setModal] = useState(null)
  const archiveRow = async (row) => { if (!window.confirm('Archivovať obhliadku „' + (row.nazov_dopytu || row.id) + '"?')) return; try { await fetchAuth(`${CFG.apiBase}/${row.id}/archive`, { method: 'POST' }); toast.success('Archivované'); load() } catch (e) { toast.error('Nepodarilo sa: ' + e.message) } }

  const load = useCallback(async () => {
    setLoading(true)
    try { const r = await fetchAuth(CFG.apiBase); const d = await r.json(); setRows(Array.isArray(d) ? d : (d.rows || [])) }
    catch (_) { toast.error('Obhliadky sa nenačítali.') } finally { setLoading(false) }
  }, [toast])
  useEffect(() => { load() }, [load])

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    return rows.filter(r => {
      if (filter === 'cakacia') { if (!r.cakacia) return false }
      else if (filter !== 'all' && r.stav !== filter) return false
      if (!q) return true
      return [r.nazov_dopytu, r.adresa, r.kontakt_meno, r.obhliadku_robil, r.druh_omietky].some(v => v != null && hladaj(String(v), q))
    })
  }, [rows, search, filter])
  const selected = useMemo(() => rows.find(r => r.id === selectedId) || null, [rows, selectedId])

  // p103 (Mirko 22. 9. 2026: „prejsť rýchlo z kontaktu do zamestnanca alebo partnera"): ?open=<id> otvorí kartu
  const [openZKontaktov, setOpenZKontaktov] = useState(() => { try { return new URLSearchParams(window.location.search).get('open') } catch (_) { return null } })
  useEffect(() => {
    if (!openZKontaktov || !rows || !rows.length) return
    const r = rows.find(x => String(x.id) === String(openZKontaktov)); setOpenZKontaktov(null)
    if (r) { setSelectedId(r.id) }
  }, [rows])  // eslint-disable-line react-hooks/exhaustive-deps
  const kpi = useMemo(() => ({ total: rows.length, open: rows.filter(r => !['vyhrana', 'prehrana'].includes(r.stav)).length, cp: rows.filter(r => r.stav === 'cp').length }), [rows])

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  // Nová obhliadka BEZ modalu (Mirko 27.7.: „dá sa vytvoriť aj po telefóne — desktop musí mať
  // všetky náležitosti"): založ prázdnu → vyber → plný editor v pravom stĺpci.
  const createNew = useCallback(async () => {
    try {
      const r = await fetchAuth(CFG.apiBase, { method: 'POST', body: JSON.stringify({
        nazov_dopytu: '', stav: 'dopyt', datum_obhliadky: todayLocal() }) })
      const d = await r.json(); if (!r.ok) throw new Error(d.error || 'HTTP ' + r.status)
      await load(); setSelectedId(d.id)
      toast.success('Nová obhliadka — vyplň náležitosti vpravo.')
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) }
  }, [load, toast])
  useListKeyboard({
    items: filtered,
    selectedId,
    onSelect: (id) => confirmLeave().then(ok => ok && setSelectedId(id)),
    onOpen: openRecord,
    enabled: !modal,
  })
  useShortcuts([
    { keys: '/', label: 'Hľadať', scope: 'obhliadky', handler: () => {
      const el = document.querySelector('[data-obhliadky-search]')
      if (el) el.focus()
    } },
  ])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title="Obhliadky" subtitle={`${filtered.length} z ${rows.length} · Komercia`}>
        <BtnAdd onClick={createNew}>+ Nová obhliadka</BtnAdd>
      </PageHeader>
      <KpiRow cols={3}>
        <KpiCard title="Spolu" color={COLORS.nav} value={kpi.total} />
        <KpiCard title="Otvorené" color={COLORS.brand} value={kpi.open} />
        <KpiCard title="V CP" color={COLORS.add} value={kpi.cp} />
      </KpiRow>
      <div style={{ height: SPACE.md }} />
      <MasterDetail
        left={<>
          <SearchInput value={search} onChange={setSearch} dataAttr="data-obhliadky-search" placeholder="Hľadať obhliadku…" />
          <FilterChips options={STATUS_FILTERS} value={filter} onChange={setFilter} />
          <div ref={listRef} style={{ flex: 1, overflow: 'auto', padding: 6 }}>
            {loading ? <div style={pad}>Načítavam…</div>
              : filtered.length === 0 ? <div style={pad}>Žiadne obhliadky.</div>
              : filtered.map(row => (
                <ListRow key={row.id} dataId={row.id} selected={row.id === selectedId} stripColor={stavColor(row.stav)}
                  onClick={() => confirmLeave().then(ok => ok && setSelectedId(row.id))} onDoubleClick={() => setModal({ record: row })}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, wordBreak: 'break-word' }}>{row.nazov_dopytu || '(bez názvu)'}</div>
                      {/* Pod-riadok podľa ústavy 66.2: ID monospace · doplňujúce info + stav e-mailu */}
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2, fontFamily: TYPO.mono }}>
                        {[row.id, row.obhliadku_robil, fmtD(row.datum_obhliadky), row.adresa].filter(Boolean).join(' · ')}
                      </div>
                      <div style={{ fontSize: TYPO.sizes.xs, marginTop: 2 }}><EmailStav row={row} /></div>
                    </div>
                    <span style={{ flexShrink: 0, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: stavColor(row.stav), background: TINT.nav, borderRadius: RADIUS.sm, padding: '1px 7px' }}>
                      {STAV_LABEL[row.stav] || row.stav}{row.cakacia ? ' · čakacia' : ''}
                    </span>
                    <RowMenu actions={[
                      { label: 'Upraviť', onClick: () => setModal({ record: row }) },
                      { label: 'Duplikovať', icon: '⧉', onClick: async () => {
                        try {
                          const r = await fetchAuth(`/api/obhliadky/${row.id}/duplicate`, { method: 'POST' })
                          const d = await r.json()
                          if (!r.ok) throw new Error(d.error || 'chyba')
                          toast.success('Duplikát vytvorený — uprav detaily.')
                          await load()
                          setSelectedId(d.id)
                        } catch (e) { toast.error('Duplikát sa nepodaril: ' + e.message) }
                      } },
                      { label: 'Archív', onClick: () => archiveRow(row) },
                    ]} />
                  </div>
                </ListRow>
              ))}
          </div>
          <ListStatusBar>↑↓ výber · dvojklik = upraviť</ListStatusBar>
        </>}
        right={selected
          ? <DetailPane record={selected} confirm={confirm} toast={toast} onEdit={() => setModal({ record: selected })} onReload={load} />
          : <EmptyPane text="Vyber obhliadku zo zoznamu vľavo" />}
      />
      {modal && <RecordModal open record={modal.record} user={user}
        onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); toast.success('Uložené.') }} />}
    </div>
  )
}

function DetailPane({ record, confirm, toast, onEdit, onReload }) {
  const [tab, setTab] = useState('detail')
  const [mailOpen, setMailOpen] = useState(false)
  const [cpPicker, setCpPicker] = useState(false)   // priradiť existujúcu CP cez vyhľadávacie pole (Mirko 22.7.)
  // mail stav presunuty do zdielaneho SendCustomerDialog (jeden system, Mirko 27.7.)
  const navigate = useNavigate()
  const r = record
  let sluzby = {}, informoval = []
  try { sluzby = JSON.parse(r.sluzby_json || '{}') } catch (_) {}
  try { informoval = JSON.parse(r.informoval_json || '[]') } catch (_) {}
  const sluzbyTxt = ['potery', 'zateplenie', 'malovanie', 'ine'].filter(k => sluzby[k]).map(k => k + (sluzby[k + '_popis'] ? ' (' + sluzby[k + '_popis'] + ')' : '')).join(', ')
  const mapsHref = r.maps_link || (r.gps_lat ? `https://maps.google.com/?q=${r.gps_lat},${r.gps_lng}` : '')

  // Doplniť ODPORÚČANIE z obhliadky do internej (neviditeľnej) poznámky CP — ceny mení používateľ (Mirko 22.7.)
  const doplnitOdporucanie = async () => {
    if (!r.quote_id) return
    const odp = ['Adresa: ' + (r.adresa || '—'), r.druh_omietky && 'Omietka: ' + r.druh_omietky,
      r.vymera_omietky && 'Odporúčaná výmera: ' + r.vymera_omietky + ' m²', r.cena_m2 && 'Návrh ceny (uprav ručne): ' + r.cena_m2 + ' €/m²',
      r.stropy && 'Stropy' + (r.stropy_priplatok ? ' +' + r.stropy_priplatok + ' €/m²' : ''), r.sietka && 'Výstuž celoplošne',
      r.poznamka && 'Pozn. z obhliadky: ' + r.poznamka].filter(Boolean).join(' · ')
    const ok = await confirm({ title: 'Doplniť odporúčanie do CP?', message: 'Do internej (neviditeľnej) poznámky ponuky ' + r.quote_id + ' pridám odporúčania z obhliadky. Ceny v ponuke NEZMENÍM — tie upravíš ručne v CP.', confirmLabel: 'Doplniť odporúčanie' })
    if (!ok) return
    try {
      const cur = await fetchAuth('/api/quotes/' + r.quote_id).then(x => x.json()).catch(() => ({}))
      const stamp = '[Z obhliadky ' + r.id + ' · ' + (r.datum_obhliadky || '').slice(0, 10) + '] ' + odp
      const merged = (cur.internal_note ? cur.internal_note + '\n' : '') + stamp
      const pr = await fetchAuth('/api/quotes/' + r.quote_id, { method: 'PUT', body: JSON.stringify({ ...cur, internal_note: merged }) })
      if (!pr.ok) throw new Error('HTTP ' + pr.status)
      toast.success('Odporúčanie doplnené do internej poznámky CP ' + r.quote_id + ' — ceny uprav v ponuke.')
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) }
  }

  // p71 (Mirko 2026-09-20): „ak už kalkulácii predchádzala obhliadka, samozrejme možnosť
  // z obhliadky vytvoriť kalkuláciu." Prenesie sa hlavička (zákazník, stavba, kontakt) aj to,
  // čo sme na obhliadke namerali — druh omietky, výmera, stropy, sieťka — aby kalkulačka
  // otvorila predvyplnená. Väzba obhliadka → kalkulácia sa nesie ďalej.
  const createKalk = async () => {
    const ok = await confirm({ title: 'Vytvoriť kalkuláciu z obhliadky?',
      message: 'Založí kalkuláciu s údajmi z obhliadky (zákazník, stavba, kontakt, výmera, druh omietky) a otvorí Kalkulácie.',
      confirmLabel: 'Vytvoriť kalkuláciu' })
    if (!ok) return
    try {
      const cement = /cement|vápenno/i.test(String(r.druh_omietky || ''))
      const vstup = {
        remeslo: 'omietka',
        typ_omietky: cement ? 'cement' : 'sadra',
        m2_steny: Number(r.vymera_omietky) || '',
        stropy: !!r.stropy,
        sietka: r.sietka ? 'celoplosne' : 'nie',
      }
      const zhrnutie = [r.adresa && 'Adresa: ' + r.adresa, r.druh_omietky && 'Omietka: ' + r.druh_omietky,
        r.vymera_omietky && 'Výmera: ' + r.vymera_omietky + ' m²', r.stropy && 'Omietanie stropov',
        r.sietka && 'Výstuž celoplošne'].filter(Boolean).join(' · ')
      const res = await fetchAuth('/api/kalkulacie', { method: 'POST', body: JSON.stringify({
        nazov: r.nazov_dopytu || ('Kalkulácia — ' + (r.adresa || 'obhliadka ' + r.id)),
        customer_id: r.customer_id || '', stavba: r.nazov_dopytu || r.adresa || '',
        telefon: normPhone(r.telefon) || '', email: r.email || '', email2: r.email2 || '',
        pripravil: r.obhliadku_robil || '', obhliadku_vykonal: r.obhliadku_robil || '',
        obhliadka_id: String(r.id || ''), dopyt_id: String(r.dopyt_id || ''),
        poznamka: zhrnutie ? 'Z obhliadky: ' + zhrnutie : '',
        data: { vstup, zdroj: 'obhliadka', obhliadka_id: String(r.id || '') },
      }) })
      const j = await res.json().catch(() => ({}))
      if (!res.ok) { toast.error(j.error || 'Kalkuláciu sa nepodarilo založiť'); return }
      toast.success('Kalkulácia ' + (j.cislo || '') + ' založená z obhliadky')
      navigate(j.id ? odkazNaZaznam('/kalkulacie', j.id) : '/kalkulacie')   // CP_OTVOR_V1
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  const createCp = async () => {
    // Blokácia duplicity (Mirko 15.7.): z jednej obhliadky = jedna CP. Ak už existuje, otvor ju.
    if (r.quote_id) {
      // (a) mŕtva väzba (Mirko 20.7.): CP mohla byť medzitým zmazaná — over, vyčisti a pokračuj
      const chk = await fetchAuth('/api/quotes/' + r.quote_id).catch(() => null)
      if (chk && chk.ok) {
        const ot = await confirm({ title: 'CP už existuje', message: `Z tejto obhliadky už bola vytvorená cenová ponuka ${r.quote_id}. Otvoriť ju namiesto vytvorenia ďalšej?`, confirmLabel: 'Otvoriť CP' })
        if (ot) navigate(odkazNaZaznam('/cenove', r.quote_id))
        return
      }
      try { await fetchAuth(`${CFG.apiBase}/${r.id}/create-cp`, { method: 'POST', body: JSON.stringify({ quote_id: '' }) }) } catch (_) {}
      toast.success(`CP ${r.quote_id} už neexistuje — mŕtva väzba vyčistená, vytváram novú.`)
    }
    const ok = await confirm({ title: 'Vytvoriť CP z obhliadky?', message: 'Založí cenovú ponuku s predvyplnenými údajmi z obhliadky a otvorí Cenové ponuky.', confirmLabel: 'Vytvoriť CP' })
    if (!ok) return
    try {
      const summary = [r.adresa && 'Adresa: ' + r.adresa, r.druh_omietky && 'Omietka: ' + r.druh_omietky,
        r.vymera_omietky && 'Výmera: ' + r.vymera_omietky + ' m²', r.stropy && 'Omietanie stropov' + (r.stropy_priplatok ? ' ' + r.stropy_priplatok + ' €/m²' : ''),
        r.sietka && 'Výstuž celoplošne'].filter(Boolean).join(' · ')
      const qr = await fetchAuth('/api/quotes', { method: 'POST', body: JSON.stringify({
        customerId: r.customer_id || '', stavba: r.nazov_dopytu || '',
        contact: [r.kontakt_meno, normPhone(r.telefon)].filter(Boolean).join(' · ') || '+421 918 443 675',
        // Mirko 3.8.: telefon + email z obhliadky IDU aj do vlastnych poli CP (predtym sa strácali)
        contact_phone: normPhone(r.telefon) || '',
        contact_email: r.email || '',
        contact_email2: r.email2 || '',
        // cp_osoba_ui_v1 (ústava 0.J.M): žiadne natvrdo dopísané meno. Keď obhliadku nikto nemá
        // zapísanú, pole sa nechá prázdne a server doplní prihlásený účet — nevymýšľa sa človek.
        prepared_by: r.obhliadku_robil || '', inspected_by: r.obhliadku_robil || '',
        // Mirko 2026-07-15: sumar obhliadky = INTERNA poznamka (nikdy do PDF; predtym notes unikalo do Priplatkov)
        internal_note: 'Z obhliadky ' + r.id + (summary ? ' — ' + summary : ''),
        // Mirko 2026-07-20: poznamka z obhliadky = VIDITELNA na CP pre zakaznika (custom_text -> sekcia Poznamky v PDF), editovatelna v CP
        custom_text: r.poznamka || '',
      }) })
      if (!qr.ok) throw new Error('CP sa nevytvorila')
      const q = await qr.json()
      if (r.vymera_omietky && r.cena_m2) {
        try {
          await fetchAuth(`/api/quotes/${q.id}/lines`, { method: 'POST', body: JSON.stringify({
            title: (r.druh_omietky || 'Omietka') + ' – steny' + (r.stropy ? ' + stropy' : ''),
            full_name: (r.druh_omietky || 'Omietka'), unit: 'm²', qty: r.vymera_omietky, price: r.cena_m2,
          }) })
        } catch (_) {}
      }
      try { await fetchAuth(`${CFG.apiBase}/${r.id}/create-cp`, { method: 'POST', body: JSON.stringify({ quote_id: q.id }) }) } catch (_) {}
      toast.success('CP ' + q.id + ' vytvorená z obhliadky')
      onReload()
      // CP_OTVOR_V1 (Mirko 22. 10. 2026: „vytvoril som CP z obhliadky a preplo ma na CP o tri ponuky nižšie“):
      // bez čísla Cenové ponuky otvorili naposledy vybranú CP z pamäte pozície — odkaz nesie číslo novej CP
      navigate(odkazNaZaznam('/cenove', q.id))
    } catch (e) { toast.error(e.message) }
  }
  const openPdf = async () => {
    try {
      if (!(await pripravDokument(toast))) return   // p95
      const x = await fetchAuth(`${CFG.apiBase}/${r.id}/pdf`)
      if (!x.ok) throw new Error('PDF zlyhalo')
      const blob = await x.blob(); const url = URL.createObjectURL(blob); window.open(url, '_blank')
    } catch (e) { toast.error(e.message) }
  }
  // Sumár pred odoslaním (ústava 531 ConsequencePreview) — ukáž Komu/Predmet/Text/Príloha, potom Odoslať.
  const openMail = async () => { if (await pripravDokument(toast)) setMailOpen(true) }   // p95: najprv uložiť (ústava 67.15)   // dialog ma Komu editovatelne — neblokujeme pri chybajucom e-maile

  const archive = async () => {
    const ok = await confirm({ title: 'Archivovať obhliadku?', message: 'Presunie sa do archívu.', confirmLabel: 'Archivovať', danger: true })
    if (!ok) return
    try { await fetchAuth(`${CFG.apiBase}/${r.id}/archive`, { method: 'POST' }); toast.success('Archivované'); onReload() } catch (e) { toast.error(e.message) }
  }

  return (
    <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={{ height: 4, background: stavColor(r.stav) }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, padding: `${SPACE.md}px ${SPACE.lg}px`, borderBottom: `1px solid ${COLORS.line}`, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, color: COLORS.text }}>{r.nazov_dopytu || 'Obhliadka'}</h2>
        <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: stavColor(r.stav), background: TINT.nav, borderRadius: RADIUS.sm, padding: '1px 8px' }}>{STAV_LABEL[r.stav] || r.stav}</span>
        <div style={{ flex: 1 }} />
        <Btn variant="nav" onClick={onEdit}>Upraviť</Btn>
        <Btn variant="nav" onClick={openPdf}>PDF</Btn>
        <Btn variant="nav" onClick={openMail}>Poslať zákazníkovi</Btn>
        {r.quote_id
          ? <><Btn variant="nav" onClick={doplnitOdporucanie}>Doplniť odporúčanie do CP</Btn><Btn variant="add" onClick={() => navigate(odkazNaZaznam('/cenove', r.quote_id))}>Otvoriť CP {r.quote_id} →</Btn></>
          : <><Btn variant="nav" onClick={() => setCpPicker(true)}>Priradiť CP</Btn><Btn variant="nav" onClick={createKalk}>Vytvoriť kalkuláciu →</Btn><Btn variant="add" onClick={createCp}>Vytvoriť CP →</Btn></>}
        <BtnGhost onClick={archive}>Archív</BtnGhost>
      </div>
      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
        <Tabs value={tab} onChange={setTab} tabs={[{ key: 'detail', label: 'Detail' }, { key: 'history', label: 'História' }]} />
        {tab === 'detail' ? (
          /* PLNÝ EDITOR v pravom stĺpci (Mirko 27.7.) — horná časť DOPYT A KONTAKT,
             spodná časť náležitosti (omietky/poter), vizuálne oddelené. Všetky polia ako mview. */
          <ObhliadkaEditor record={r} onSaved={onReload} />
        ) : <HistoryPanel module={CFG.resource} entityId={r.id} />}
      </div>
      {cpPicker && <CpPickerModal obhliadka={r} onDone={(cpId) => { setCpPicker(false); toast.success('CP priradená k obhliadke'); onReload() }} onClose={() => setCpPicker(false)} />}
      <SendCustomerDialog open={mailOpen} onClose={() => setMailOpen(false)}
        title="Poslať zákazníkovi — protokol z obhliadky"
        customerId={r.customer_id || ''}
        initTo={r.email || ''} initCc={r.email2 || ''} phone={normPhone(r.telefon || '')}
        initSubject={'Protokol z obhliadky — ' + (r.nazov_dopytu || r.id)}
        initText={'Dobrý deň,\n\nv prílohe Vám posielame protokol z obhliadky. V prípade záujmu radi pripravíme cenovú ponuku.\n\nTento e-mail bol vygenerovaný automaticky ako potvrdenie vykonanej obhliadky. Údaje získané počas obhliadky budú podkladom na vypracovanie cenovej ponuky.\n\nS pozdravom,\nKAMIR s.r.o.'}
        attachmentName={'Obhliadka_' + r.id + '.pdf'} attachmentNote="protokol sa vygeneruje automaticky."
        footNote="Odosiela sa z firemnej schránky KAMIR. Kópia ostane v odoslanej pošte."
        smsLabel="SMS, že mu bol odoslaný protokol z obhliadky"
        smsText={'Dobry den, prave sme Vam poslali protokol z obhliadky na e-mail. V pripade otazok volajte 0918 443 675. KAMIR'}
        smsEntityType={r.dopyt_id ? 'dopyt' : ''} smsEntityId={r.dopyt_id || ''}
        onSend={async ({ to, cc, subject, text }) => {
          const x = await fetchAuth(`${CFG.apiBase}/${r.id}/send-customer`, { method: 'POST', body: JSON.stringify({ email: to, cc, subject, text }) })
          const d = await x.json(); if (!x.ok) throw new Error(d.error || 'Zlyhalo')
          return { to: d.to }
        }}
        onSent={() => { setMailOpen(false); onReload() }} />
    </div>
  )
}
// Picker existujúcej CP — vyhľadávacie pole (nie zadávanie čísla), Matrix vzor (Mirko 22.7. „polom hľadať")
function CpPickerModal({ obhliadka, onDone, onClose }) {
  const [quotes, setQuotes] = useState([])
  const [q, setQ] = useState('')
  const [busy, setBusy] = useState(false)
  useEffect(() => { fetchAuth('/api/quotes').then(r => r.json()).then(d => setQuotes(Array.isArray(d) ? d : (d.quotes || []))).catch(() => {}) }, [])
  useEffect(() => { const h = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose() } }; window.addEventListener('keydown', h, true); return () => window.removeEventListener('keydown', h, true) }, [onClose])
  const norm = (x) => String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  const fp = quotes.filter(x => { const s = norm(q); return !s || norm([x.id, x.quote_number, x.stavba, x.contact].join(' ')).includes(s) })
    .sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || ''))).slice(0, 60)
  const pick = async (cp) => {
    if (busy) return; setBusy(true)
    try {
      const r = await fetchAuth('/api/obhliadky/' + obhliadka.id + '/create-cp', { method: 'POST', body: JSON.stringify({ quote_id: cp.id }) })
      if (!r.ok) throw new Error('HTTP ' + r.status)
      onDone(cp.id)
    } catch (e) { alert('Nepodarilo sa priradiť: ' + e.message); setBusy(false) }
  }
  const inp = { width: '100%', padding: '9px 12px', border: '1px solid #d6dde6', borderRadius: 9, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box', outline: 'none', marginBottom: 8 }
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 20, width: 'min(580px,94vw)', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <div style={{ fontWeight: 800, fontSize: 16 }}>Priradiť existujúcu CP k obhliadke</div>
          <button onClick={onClose} style={{ marginLeft: 'auto', padding: '6px 10px', border: 'none', background: '#f1f5f9', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit' }}>✕</button>
        </div>
        <div style={{ fontSize: 12.5, color: '#64748b', marginBottom: 10 }}>„{obhliadka.nazov_dopytu || obhliadka.kontakt_meno || 'obhliadka'}" — nájdi cenovú ponuku a klikni na ňu.</div>
        <input value={q} onChange={e => setQ(e.target.value)} autoFocus placeholder="Hľadať CP — číslo, stavba, zákazník…" style={inp} />
        <div style={{ overflowY: 'auto', flex: 1, border: '1px solid #eef2f7', borderRadius: 8 }}>
          {!fp.length ? <div style={{ padding: 12, color: '#94a3b8', fontSize: 13 }}>Žiadna CP nevyhovuje.</div> :
            fp.map(cp => (
              <div key={cp.id} onClick={() => pick(cp)} style={{ padding: '9px 12px', cursor: busy ? 'wait' : 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13 }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                <b>{cp.quote_number || cp.id}</b>{cp.stavba ? ' · ' + cp.stavba : ''}
                <span style={{ color: '#94a3b8' }}>{cp.contact ? ' · ' + cp.contact : ''}{cp.sent_at ? ' · odoslaná' : ''}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

function Grp({ children }) { return <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.brand, textTransform: 'uppercase', letterSpacing: '0.04em', margin: '14px 0 6px', borderBottom: `1px solid ${COLORS.lineSoft}`, paddingBottom: 3 }}>{children}</div> }
function D({ l, v, extra }) { return <div style={{ display: 'flex', gap: SPACE.md, padding: '3px 0' }}><span style={{ width: 150, color: COLORS.muted, flexShrink: 0 }}>{l}</span><span style={{ color: COLORS.text }}>{v || '—'}{extra}</span></div> }
const pad = { padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }

function compressPhoto(file) { return new Promise(res => { try {
  const img = new Image(); const u = URL.createObjectURL(file)
  img.onload = () => { try { const MAX = 1600; let w = img.width, h = img.height; const r = Math.min(1, MAX / Math.max(w, h)); w = Math.round(w * r); h = Math.round(h * r)
    const c = document.createElement('canvas'); c.width = w; c.height = h; c.getContext('2d').drawImage(img, 0, 0, w, h)
    c.toBlob(b => { URL.revokeObjectURL(u); res(b && b.size < file.size ? b : file) }, 'image/jpeg', 0.82)
  } catch (e) { URL.revokeObjectURL(u); res(file) } }
  img.onerror = () => { URL.revokeObjectURL(u); res(file) }; img.src = u
} catch (e) { res(file) } }) }

function RecordModal({ open, record, user, onClose, onSaved }) {
  const isNew = !record
  const ed = useRecordEditor({
    resource: CFG.resource, id: record?.id || null, user,
    initial: {
      nazov_dopytu: record?.nazov_dopytu || '', customer_id: record?.customer_id || '', kontakt_meno: record?.kontakt_meno || '', telefon: record?.telefon || '',
      email: record?.email || '', adresa: record?.adresa || '', datum_obhliadky: record?.datum_obhliadky || todayLocal(),
      termin_real: record?.termin_real || '', druh_nehnutelnosti: record?.druh_nehnutelnosti || '', murivo: record?.murivo || '',
      druh_omietky: record?.druh_omietky || '', vymera_omietky: record?.vymera_omietky || '', cena_m2: record?.cena_m2 || '',
      stav: record?.stav || 'dopyt', obhliadku_robil: record?.obhliadku_robil || '', poznamka: record?.poznamka || '',
      foto: (() => { try { return JSON.parse(record?.foto_json || '[]') } catch (_) { return [] } })(),
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const r = await fetchAuth(isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`, { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(values) })
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Uloženie zlyhalo.') }
    },
  })
  const toast = useToast()
  const [customers, setCustomers] = useState([])
  const [novyOpen, setNovyOpen] = useState(false)
  const [novyPrefill, setNovyPrefill] = useState('')
  useEffect(() => { fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomers(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  // Napojenie na partnera z číselníka (ústava 2931/2991 — zákazník = partner, nie voľný text)
  const pickCustomer = (c) => {
    const patch = { customer_id: c.id, kontakt_meno: c.name || ed.values.kontakt_meno }
    if (!ed.values.telefon && c.phone) patch.telefon = c.phone
    if (!ed.values.email && c.email) patch.email = c.email
    if (!ed.values.adresa && c.address) patch.adresa = c.address
    ed.setValues(patch)
  }
  if (!open) return null
  const doClose = () => ed.requestClose(onClose)
  const validate = (v) => { if (!v.nazov_dopytu || !v.nazov_dopytu.trim()) return 'Názov dopytu je povinný.'; return null }
  const handleConfirm = async () => { const ok = await ed.submit(); if (ok) onSaved() }
  const ro = !ed.canEdit
  return (<>
    <Modal open onClose={doClose} onDirtyClose={doClose} isDirty={ed.isDirty}
      title={isNew ? 'Nová obhliadka (telefonický dopyt)' : `Upraviť — ${record.nazov_dopytu}`}
      subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny' : 'Plný formulár (vrátane GPS/služieb) je v mobile'} maxWidth={680}
      footer={ed.phase === 'form'
        ? (<><BtnGhost onClick={doClose}>Zrušiť</BtnGhost><BtnAdd onClick={() => ed.goConfirm(validate)} disabled={ro}>Uložiť →</BtnAdd></>)
        : (<><BtnGhost onClick={ed.back}>← Späť</BtnGhost><BtnAdd onClick={handleConfirm} disabled={ed.submitting}>{ed.submitting ? 'Ukladám…' : '✓ Potvrdiť'}</BtnAdd></>)}>
      {ro && ed.lockedBy && <div style={box}>Upravuje <strong>{ed.lockedBy}</strong>.</div>}
      {ed.error && <div style={box}>{ed.error}</div>}
      {ed.phase === 'form' ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
          <F l="Názov dopytu *"><input value={ed.values.nazov_dopytu} disabled={ro} onChange={e => ed.set('nazov_dopytu', e.target.value)} style={inp} /></F>
          <F l="Zákazník (z číselníka)">
            <div style={{ display: 'flex', gap: 6 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <SearchableSelect value={ed.values.customer_id || ''} menuPortal allowCreate
                  onChange={v => {
                    const c = customers.find(x => x.id === v)
                    if (c) pickCustomer(c)
                    else if (v && String(v).trim()) { setNovyPrefill(String(v).trim()); setNovyOpen(true) }
                    else ed.set('customer_id', '')
                  }}
                  options={customers.map(c => ({ value: c.id, label: `${c.name} (${c.id})` }))}
                  placeholder="Hľadať podľa mena alebo IČO…" />
              </div>
              <button type="button" disabled={ro} onClick={() => { setNovyPrefill(ed.values.kontakt_meno || ''); setNovyOpen(true) }}
                style={{ padding: '0 12px', border: `1px solid ${COLORS.brand}`, background: COLORS.bg, color: COLORS.brand, borderRadius: RADIUS.md, cursor: 'pointer', fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', whiteSpace: 'nowrap' }}
                title="Nový zákazník — vyhľadanie v ORSR/VIES">+ Nový</button>
            </div>
            {!ed.values.customer_id && ed.values.kontakt_meno
              ? <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.brand, marginTop: 4 }}>Zapísané meno „{ed.values.kontakt_meno}" nie je napojené na číselník — vyber vyššie alebo vytvor cez „+ Nový".</div>
              : null}
          </F>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
            <F l="Telefón"><TelefonInput value={ed.values.telefon} disabled={ro} onChange={v => ed.set('telefon', v)} style={inp} /></F>
            <F l="E-mail"><input value={ed.values.email} disabled={ro} onChange={e => ed.set('email', e.target.value)} style={inp} /></F>
            <F l="Adresa"><input value={ed.values.adresa} disabled={ro} onChange={e => ed.set('adresa', e.target.value)} style={inp} /></F>
            <F l="Dátum obhliadky"><input type="date" value={ed.values.datum_obhliadky} disabled={ro} onChange={e => ed.set('datum_obhliadky', e.target.value)} style={inp} /></F>
            <F l="Termín"><input value={ed.values.termin_real} disabled={ro} onChange={e => ed.set('termin_real', e.target.value)} style={inp} /></F>
            <F l="Druh nehnuteľnosti"><input value={ed.values.druh_nehnutelnosti} disabled={ro} onChange={e => ed.set('druh_nehnutelnosti', e.target.value)} style={inp} /></F>
            <F l="Murivo"><input value={ed.values.murivo} disabled={ro} onChange={e => ed.set('murivo', e.target.value)} style={inp} /></F>
            <F l="Druh omietky"><input value={ed.values.druh_omietky} disabled={ro} onChange={e => ed.set('druh_omietky', e.target.value)} style={inp} /></F>
            <F l="Výmera omietky (m²)"><input type="number" value={ed.values.vymera_omietky} disabled={ro} onChange={e => ed.set('vymera_omietky', e.target.value)} style={inp} /></F>
            <F l="Cena €/m²"><input type="number" value={ed.values.cena_m2} disabled={ro} onChange={e => ed.set('cena_m2', e.target.value)} style={inp} /></F>
            <F l="Obhliadku robil"><input value={ed.values.obhliadku_robil} disabled={ro} onChange={e => ed.set('obhliadku_robil', e.target.value)} style={inp} /></F>
          </div>
          <F l="Stav"><SearchableSelect value={ed.values.stav} onChange={v => ed.set('stav', v)} options={Object.keys(STAV_LABEL).map(k => ({ value: k, label: STAV_LABEL[k] }))} /></F>
          <F l="Poznámka"><textarea value={ed.values.poznamka} disabled={ro} onChange={e => ed.set('poznamka', e.target.value)} rows={2} style={{ ...inp, resize: 'vertical' }} /></F>
          <F l="Fotky">
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
              {(ed.values.foto || []).map((u, i) => <span key={i} style={{ position: 'relative', display: 'inline-block' }}>
                <img src={u} alt="" style={{ width: 84, height: 62, objectFit: 'cover', borderRadius: 6, border: `1px solid ${COLORS.line}` }} />
                {!ro && <button type="button" onClick={() => ed.set('foto', ed.values.foto.filter((_, j) => j !== i))} style={{ position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: 10, border: 'none', background: '#b91c1c', color: '#fff', fontSize: 11, cursor: 'pointer', lineHeight: '20px', padding: 0 }}>x</button>}
              </span>)}
              {!ro && <label style={{ padding: '8px 12px', border: `1px dashed ${COLORS.line}`, borderRadius: 8, fontSize: 13, cursor: 'pointer', color: COLORS.muted }}>+ Pridať fotky
                <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={async e => {
                  const files = [...(e.target.files || [])]; e.target.value = ''
                  for (const file of files) {
                    try {
                      const small = await compressPhoto(file)
                      const fd = new FormData(); fd.append('file', small, 'foto.jpg')
                      const r = await fetch('/api/obhliadky/upload-photo', { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('kamir_token') || ''}` }, body: fd })
                      const j = await r.json()
                      if (j.url) ed.set('foto', [...(ed.values.foto || []), j.url]); else toast.error(j.error || 'Fotka sa nenahrala')
                    } catch (_) { toast.error('Fotka sa nenahrala') }
                  }
                }} /></label>}
            </div>
          </F>
        </div>
      ) : (
        <div>{isNew ? <p style={{ color: COLORS.text }}>Vytvorí sa obhliadka <strong>{ed.values.nazov_dopytu}</strong>.</p>
          : ed.diff.length === 0 ? <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
          : <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
              <thead><tr style={{ background: TINT.nav }}><th style={th}>Pole</th><th style={th}>Pôvodné</th><th style={th}>Nové</th></tr></thead>
              <tbody>{ed.diff.map(x => <tr key={x.name}><td style={td}>{x.label}</td><td style={{ ...td, color: COLORS.muted, textDecoration: 'line-through' }}>{x.from}</td><td style={{ ...td, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>{x.to}</td></tr>)}</tbody>
            </table>}</div>
      )}
    </Modal>
    <Modal.DirtyConfirm {...ed.dirtyProps} />
    <NoviCustomerDialog open={novyOpen} prefillName={novyPrefill}
      onClose={() => { setNovyOpen(false); setNovyPrefill('') }}
      onCreated={c => { setCustomers(prev => [...prev, c]); pickCustomer(c); setNovyOpen(false); setNovyPrefill('') }} />
  </>)
}
function F({ l, children }) { return <label style={{ display: 'block' }}><div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{l}</div>{children}</label> }
const inp = { width: '100%', padding: '6px 10px', fontSize: TYPO.sizes.base, fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, outline: 'none', boxSizing: 'border-box' }
const box = { background: TINT.remove, border: `1px solid ${COLORS.remove}`, borderRadius: RADIUS.md, padding: SPACE.sm, marginBottom: SPACE.md, fontSize: TYPO.sizes.sm, color: COLORS.remove }
const th = { textAlign: 'left', padding: '6px 10px', fontSize: TYPO.sizes.xs, color: COLORS.nav, textTransform: 'uppercase', borderBottom: `1px solid ${COLORS.line}` }
const td = { padding: '6px 10px', borderBottom: `1px solid ${COLORS.lineSoft}` }
